// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/slide-1-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,500;1,600;1,700;1,800;1,900&family=Nunito+Sans:opsz,wght@6..12,900&family=Source+Sans+3&display=swap');

.bg-img-1 {
    background-image: url('../../assets/images/slide-1-bg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.hero-banner-block .container-fluid {
    height: 780px;
    background: linear-gradient(97.58deg, rgba(0, 134, 63, 0.22) 18.19%, rgba(0, 134, 63, 0) 68.93%);
    padding: 0 30px;
}

.banner-title {
    font-family: Montserrat;
    font-size: 48px;
    font-weight: 700;
    line-height: 59px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.banner-title .highlighted {
    color: #00863F;
    font-weight: 700;
}

.banner-subtitle {
    font-family: Open Sans;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.big-title {
    font-family: Nunito Sans;
    font-size: 38px;
    font-weight: 900;
    line-height: 46px;
    letter-spacing: 0em;
    text-align: center;
    text-transform: uppercase;

}

.body-text {
    font-family: 'Source Sans 3', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: center;
}

.grey-bg {
    background-color: #FAFAFA;
    padding: 20px;
    padding-bottom: 0;
}



.dark-grey-bg {
    background-color: #F0F0F0;
    padding: 20px;
    padding-bottom: 0;
}

.img-circle-wrapper {
    width: 67px;
    height: 67px;
    background-color: #55C68A;
    border-radius: 100%;
    display: inline-block;
    margin-bottom: 40px;
}

.img-circle-wrapper img {
    position: absolute;
    bottom: -40px;
    left: -25px;
}

.img-title {
    color: var(--unnamed-color-494f54);
text-align: left;
font: normal normal 200 25px/35px Manrope;
letter-spacing: 3.75px;
color: #494F54;
text-transform: uppercase;
opacity: 1;

}

.step-block {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
    max-width: 300px;
    text-align: center;
    margin: auto;
    background: var(--unnamed-color-daf1f9) 0% 0% no-repeat padding-box;
background: #DAF1F9 0% 0% no-repeat padding-box;
border-radius: 0px 116px 0px 0px;
opacity: 1;
}

.step-block .btn-link p {
    color: #00863F;
    font-family: Open Sans;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
}

.horizontal-divider {
    max-width: 40px;
    width: 100%;
    height: 4px;
    background-color: #C3C3C3;
    border-radius: 10px;
    display: inline-block;
}

.completion-status-bar.progress {
    height: 55px;
    border-radius: 0;
    background-color: #004B23;
    position: relative;
}

.completion-status-bar .progress-bar {
    background-color: #00863F;
}

.status-text {
    font-family: Open Sans;
    font-size: 15px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
} */

.hero-banner-block.bg-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.hero-banner-block .content-block {
    max-width: 984px;
}

.hero-banner-block .container {
    height: 480px;
    max-width: 1550px;
    padding: 0 30px;
    background: linear-gradient(270deg, rgba(36, 122, 61, 0.54) 0%, rgba(219, 246, 232, 0.54) 100%) 0% 0% no-repeat padding-box;
}

.banner-title {
    font-family: 'Manrope', sans-serif;
    font-size: 48px;
    font-weight: 200;
    line-height: 59px;
    letter-spacing: 0em;
    text-align: left;
    color: #494F54;
}

.banner-subtitle {
    font-family: Open Sans;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.8px;
    color: #494F54;
    text-align: left;
}

.hero-banner-block .btn-primary {
    background: #247A3D 0% 0% no-repeat padding-box;
    border-radius: 0px 32px 0px 35px;
    opacity: 1;
    text-align: left;
    font: normal normal 600 20px/27px Open Sans;
    letter-spacing: 3px;
    color: #FEF8E6;
    text-transform: lowercase;
    opacity: 1;
    height: 60px;
    transition: all 0.3s ease;
}

.hero-banner-block .btn-primary:hover {
    background: #DBF6E8 0% 0% no-repeat padding-box;
    border: 1px solid #6087F6;
    opacity: 1;
    border-radius: 0;
    text-align: left;
    font: normal normal 300 20px/27px Open Sans;
    letter-spacing: 3px;
    color: #495053;
    text-transform: lowercase;
    opacity: 1;
    transition: all 0.3s ease;
}

.big-title {
    text-align: left;
    font: normal normal 600 50px/68px Manrope;
    letter-spacing: 5px;
    color: #494F54;
    text-transform: capitalize;
    opacity: 1;
}

.body-text {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
    opacity: 1;
}

.ohs-section .container,
.assessment-section .container {
    max-width: 1550px;
    padding: 30px;
}

.cards-title {
    text-align: left;
    font: normal normal 200 40px/55px Manrope;
    letter-spacing: 4px;
    color: #494F54;
    text-transform: lowercase;
    opacity: 1;
}

.step-block {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    max-width: 470px;
    text-align: center;
    margin: 0 10px;
    background: #DAF1F9 0% 0% no-repeat padding-box;
    border-radius: 0px 116px 0px 0px;
    opacity: 1;
    padding: 31px;
}

.img-title {
    text-align: left;
    font: normal normal 200 25px/35px Manrope;
    letter-spacing: 3.75px;
    color: #494F54;
    text-transform: uppercase;
    opacity: 1;
    margin-top: 35px;
}

.img-content {
    text-align: center;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
    opacity: 1;
    flex: 1 1 auto;
}

.step-block .btn-primary p {
    text-align: left;
    font: normal normal 600 18px/24px Open Sans;
    letter-spacing: 2.7px;
    color: #FEF8E6;
    text-transform: lowercase;
    opacity: 1;
}

.step-block .btn-primary {
    padding: 15px 25px;
}

.assessment-section .step-block {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    max-width: 330px;
    text-align: center;
    margin: auto;
    background-color: transparent;
}




.progress-status-text {
    text-align: left;
    font: normal normal normal 16px/22px;
    font-family: 'Open Sans', sans-serif;
    letter-spacing: 0.8px;
    color: #247A3D;
    opacity: 1;
}

.ohs-section .CircularProgressbar .CircularProgressbar-path {
    stroke: #247A3D;
}

.ohs-section .CircularProgressbar {
    border-radius: 100%;
    background-color: #EEEEEE;
}

.ohs-section .CircularProgressbar .CircularProgressbar-text {
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    letter-spacing: 0.6px;
    fill: #247A3D;
    opacity: 1;
}

@media(max-width:767.5px){
    .big-title{
        font-size: 32px;
        line-height: 40px;
    }
    .grey-bg{
        margin-bottom: 20px;
    }
    .hero-banner-block .container {
        height: 600px;
    }
}`, "",{"version":3,"sources":["webpack://./src/screens/home/home.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiKG;;AAIH;IACI,yDAA2D;IAC3D,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,2HAA2H;AAC/H;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,+CAA+C;IAC/C,gCAAgC;IAChC,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;;;;AAKA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,oCAAoC;IACpC,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;IACrB,aAAa;IACb,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,500;1,600;1,700;1,800;1,900&family=Nunito+Sans:opsz,wght@6..12,900&family=Source+Sans+3&display=swap');\n\n.bg-img-1 {\n    background-image: url('../../assets/images/slide-1-bg.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.hero-banner-block .container-fluid {\n    height: 780px;\n    background: linear-gradient(97.58deg, rgba(0, 134, 63, 0.22) 18.19%, rgba(0, 134, 63, 0) 68.93%);\n    padding: 0 30px;\n}\n\n.banner-title {\n    font-family: Montserrat;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 59px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.banner-title .highlighted {\n    color: #00863F;\n    font-weight: 700;\n}\n\n.banner-subtitle {\n    font-family: Open Sans;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.big-title {\n    font-family: Nunito Sans;\n    font-size: 38px;\n    font-weight: 900;\n    line-height: 46px;\n    letter-spacing: 0em;\n    text-align: center;\n    text-transform: uppercase;\n\n}\n\n.body-text {\n    font-family: 'Source Sans 3', sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 27px;\n    letter-spacing: 0em;\n    text-align: center;\n}\n\n.grey-bg {\n    background-color: #FAFAFA;\n    padding: 20px;\n    padding-bottom: 0;\n}\n\n\n\n.dark-grey-bg {\n    background-color: #F0F0F0;\n    padding: 20px;\n    padding-bottom: 0;\n}\n\n.img-circle-wrapper {\n    width: 67px;\n    height: 67px;\n    background-color: #55C68A;\n    border-radius: 100%;\n    display: inline-block;\n    margin-bottom: 40px;\n}\n\n.img-circle-wrapper img {\n    position: absolute;\n    bottom: -40px;\n    left: -25px;\n}\n\n.img-title {\n    color: var(--unnamed-color-494f54);\ntext-align: left;\nfont: normal normal 200 25px/35px Manrope;\nletter-spacing: 3.75px;\ncolor: #494F54;\ntext-transform: uppercase;\nopacity: 1;\n\n}\n\n.step-block {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    max-width: 300px;\n    text-align: center;\n    margin: auto;\n    background: var(--unnamed-color-daf1f9) 0% 0% no-repeat padding-box;\nbackground: #DAF1F9 0% 0% no-repeat padding-box;\nborder-radius: 0px 116px 0px 0px;\nopacity: 1;\n}\n\n.step-block .btn-link p {\n    color: #00863F;\n    font-family: Open Sans;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 15px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.horizontal-divider {\n    max-width: 40px;\n    width: 100%;\n    height: 4px;\n    background-color: #C3C3C3;\n    border-radius: 10px;\n    display: inline-block;\n}\n\n.completion-status-bar.progress {\n    height: 55px;\n    border-radius: 0;\n    background-color: #004B23;\n    position: relative;\n}\n\n.completion-status-bar .progress-bar {\n    background-color: #00863F;\n}\n\n.status-text {\n    font-family: Open Sans;\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 15px;\n    letter-spacing: 0em;\n    text-align: left;\n    position: absolute;\n    margin: auto;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n} */\n\n@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap');\n\n.hero-banner-block.bg-img {\n    background-image: url('../../assets/images/slide-1-bg.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.hero-banner-block .content-block {\n    max-width: 984px;\n}\n\n.hero-banner-block .container {\n    height: 480px;\n    max-width: 1550px;\n    padding: 0 30px;\n    background: linear-gradient(270deg, rgba(36, 122, 61, 0.54) 0%, rgba(219, 246, 232, 0.54) 100%) 0% 0% no-repeat padding-box;\n}\n\n.banner-title {\n    font-family: 'Manrope', sans-serif;\n    font-size: 48px;\n    font-weight: 200;\n    line-height: 59px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #494F54;\n}\n\n.banner-subtitle {\n    font-family: Open Sans;\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    text-align: left;\n}\n\n.hero-banner-block .btn-primary {\n    background: #247A3D 0% 0% no-repeat padding-box;\n    border-radius: 0px 32px 0px 35px;\n    opacity: 1;\n    text-align: left;\n    font: normal normal 600 20px/27px Open Sans;\n    letter-spacing: 3px;\n    color: #FEF8E6;\n    text-transform: lowercase;\n    opacity: 1;\n    height: 60px;\n    transition: all 0.3s ease;\n}\n\n.hero-banner-block .btn-primary:hover {\n    background: #DBF6E8 0% 0% no-repeat padding-box;\n    border: 1px solid #6087F6;\n    opacity: 1;\n    border-radius: 0;\n    text-align: left;\n    font: normal normal 300 20px/27px Open Sans;\n    letter-spacing: 3px;\n    color: #495053;\n    text-transform: lowercase;\n    opacity: 1;\n    transition: all 0.3s ease;\n}\n\n.big-title {\n    text-align: left;\n    font: normal normal 600 50px/68px Manrope;\n    letter-spacing: 5px;\n    color: #494F54;\n    text-transform: capitalize;\n    opacity: 1;\n}\n\n.body-text {\n    text-align: left;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.ohs-section .container,\n.assessment-section .container {\n    max-width: 1550px;\n    padding: 30px;\n}\n\n.cards-title {\n    text-align: left;\n    font: normal normal 200 40px/55px Manrope;\n    letter-spacing: 4px;\n    color: #494F54;\n    text-transform: lowercase;\n    opacity: 1;\n}\n\n.step-block {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    align-items: center;\n    max-width: 470px;\n    text-align: center;\n    margin: 0 10px;\n    background: #DAF1F9 0% 0% no-repeat padding-box;\n    border-radius: 0px 116px 0px 0px;\n    opacity: 1;\n    padding: 31px;\n}\n\n.img-title {\n    text-align: left;\n    font: normal normal 200 25px/35px Manrope;\n    letter-spacing: 3.75px;\n    color: #494F54;\n    text-transform: uppercase;\n    opacity: 1;\n    margin-top: 35px;\n}\n\n.img-content {\n    text-align: center;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    opacity: 1;\n    flex: 1 1 auto;\n}\n\n.step-block .btn-primary p {\n    text-align: left;\n    font: normal normal 600 18px/24px Open Sans;\n    letter-spacing: 2.7px;\n    color: #FEF8E6;\n    text-transform: lowercase;\n    opacity: 1;\n}\n\n.step-block .btn-primary {\n    padding: 15px 25px;\n}\n\n.assessment-section .step-block {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    align-items: center;\n    max-width: 330px;\n    text-align: center;\n    margin: auto;\n    background-color: transparent;\n}\n\n\n\n\n.progress-status-text {\n    text-align: left;\n    font: normal normal normal 16px/22px;\n    font-family: 'Open Sans', sans-serif;\n    letter-spacing: 0.8px;\n    color: #247A3D;\n    opacity: 1;\n}\n\n.ohs-section .CircularProgressbar .CircularProgressbar-path {\n    stroke: #247A3D;\n}\n\n.ohs-section .CircularProgressbar {\n    border-radius: 100%;\n    background-color: #EEEEEE;\n}\n\n.ohs-section .CircularProgressbar .CircularProgressbar-text {\n    text-align: center;\n    font-family: 'Open Sans', sans-serif;\n    letter-spacing: 0.6px;\n    fill: #247A3D;\n    opacity: 1;\n}\n\n@media(max-width:767.5px){\n    .big-title{\n        font-size: 32px;\n        line-height: 40px;\n    }\n    .grey-bg{\n        margin-bottom: 20px;\n    }\n    .hero-banner-block .container {\n        height: 600px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
